import { Box, Button, Typography } from "@mui/material";
import React from "react";

interface ImageRedactorButtonProps {
  onClick: () => void;
  icon: React.ReactElement;
  label: string;
  active?: boolean;
  theme: any;
}

const ImageRedactorButton: React.FC<ImageRedactorButtonProps> = ({
  onClick,
  icon,
  label,
  active = false,
  theme,
}) => {
  return (
    <Button
      size="small"
      onClick={onClick}
      sx={{
        minWidth: 75,
        borderRadius: 2,
        color: active ? theme.palette.primary.main : theme.palette.grey[700],
        border: `1px solid ${
          active ? theme.palette.primary.main : theme.palette.grey[300]
        }`,
        backgroundColor: active ? theme.palette.primary.light : "transparent",
        "&:hover": {
          backgroundColor: active
            ? theme.palette.primary.light
            : theme.palette.grey[100],
        },
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap={0.5}
      >
        {React.cloneElement(icon, {
          sx: {
            padding: 0.3,
            color: active
              ? theme.palette.primary.main
              : theme.palette.grey[700],
            borderRadius: 1,
            ...icon.props.sx,
          },
        })}
        <Typography fontWeight={active ? 600 : 400} fontSize={12}>
          {label}
        </Typography>
      </Box>
    </Button>
  );
};

export default ImageRedactorButton;
